import "core-js/modules/es.array.push.js";
import { createRouter, createWebHistory } from "vue-router";
import { useSecurityStore } from "@/stores/system/security";
// import { usePermissionsStore } from "@/stores/permissions";
import userAgreement from "../layouts/user-agreement-page.vue";
import deleteProfile from "../layouts/delete-profile.vue";
import ErrorPage from "../layouts/error-page";
function loadModules() {
  const context = require.context("./modules", true, /([a-z_]+)\.js$/i);
  const keys = context.keys();
  let modules = [];
  keys.forEach(key => {
    modules.push(context(key).default);
  });
  return modules.flat();
}
const modules = loadModules();
const router = new createRouter({
  routes: [...modules, {
    path: "/",
    redirect: "home"
  }, {
    path: "/user-agreement",
    name: "user-agreement",
    component: () => import("@/layouts/user-agreement-page.vue"),
    meta: {
      requiresAuth: false,
      layout: userAgreement,
      permission: "без разрешений"
    }
  }, {
    path: "/delete-profile",
    name: "delete-profile",
    component: deleteProfile,
    meta: {
      requiresAuth: false,
      layout: deleteProfile,
      permission: "без разрешений"
    }
  }, {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    meta: {
      requiresAuth: true,
      layout: ErrorPage,
      title: 404,
      permission: "без разрешений"
    }
  }, {
    path: "/forbidden",
    name: "forbidden",
    meta: {
      requiresAuth: true,
      layout: ErrorPage,
      title: 403,
      permission: "без разрешений"
    }
  }
  // {
  // НАДО ПЕРЕПИСАТЬ УВЕДОМЛЕНИЯ
  //   path: '/:applicationName/view/:oid',
  //   redirect: to => {
  //     let applicationNameLower = to.params.applicationName.toLowerCase();
  //     let newPathSegment = '';
  //     switch (applicationNameLower) {
  //     case 'rentcarapplcation':
  //         newPathSegment = 'rent-application';
  //         break;
  //       case 'clientrentcarapplcation':
  //         newPathSegment = 'private-rent-app';
  //         break;
  //       case 'photoreport':
  //         newPathSegment = 'photo-report';
  //         break;
  //       case 'connectedbranding':
  //         newPathSegment = 'connected-branding';
  //         break;
  //       default:
  //         newPathSegment = '';
  //         break;
  //     }
  //     return newPathSegment ? { path: `/${newPathSegment}/view/${to.params.oid}` } : { path: `/` }
  //   }
  // }
  ],
  history: createWebHistory()
});
router.beforeEach((to, from, next) => {
  try {
    const securityStore = useSecurityStore();
    const permissionsStore = usePermissionsStore();
    const permissions = permissionsStore.check(to.meta.permission, "navigate");
    const requiresAuth = to.meta.requiresAuth;
    const permission = to.meta.permission;
    //console.log(permissions, to.meta.permission);

    if (!requiresAuth) {
      next();
    } else if (!securityStore.loggedIn) {
      next({
        name: "login-form",
        query: {
          redirect: to.fullPath
        }
      });
    } else if (permission === "без разрешений") {
      next();
    } else if (permissions) {
      next();
    } else next({
      name: "forbidden"
    });
  } catch (error) {
    console.log(error);
  }
});
export default router;